/// <amd-module name="Artifacts/Cargo/services/CargoRestApiUrlGeneratorService" />
import { generatePackagingServiceRestApiUri, IRestApiRoutes } from "Artifacts/Root/Utils/RestApi";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

const CargoArea = "cargo";

const CargoPackageContentLocationId: IRestApiRoutes = {
  locationId: "51E7316D-FC27-4DBC-A417-3E725BACAF4D",
  resource: "download",
  routeTemplate:
    "packaging/feeds/{feedId}/{area}/packages/{packageName}/versions/{packageVersion}/{resource}",
};

export interface ICargoRestApiUrlGeneratorService extends IVssService {
  getPackageDownloadUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string;
}

class CargoRestApiUrlGeneratorService extends VssService
  implements ICargoRestApiUrlGeneratorService {
  public getPackageDownloadUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    includeProject: false,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(CargoPackageContentLocationId.routeTemplate, {
      feedId,
      area: CargoArea,
      packageName,
      packageVersion,
      resource: CargoPackageContentLocationId.resource,
    });

    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      false /* ignoreApisRelativePath */,
      includeProject,
    );
  }
}

Services.add("ICargoRestApiUrlGeneratorService", {
  serviceFactory: CargoRestApiUrlGeneratorService,
});
